// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/thunderstorm-life-cycle.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/thunderstorm-life-cycle/storm-motion-advection-propagation.js';
import g1 from '../lessons/meteorology/thunderstorm-life-cycle/thunderstorm-life-cycle.js';

mount([g0, g1]);
